// Constructor
function GardenFlower(app, game, container, index, level) {
	this.app = app;
	this.game = game;
	this.$container = container;
	this.index = index;

	this.animating = false;

	this.waterLevel = level;
	this.waterMinLevel = 0;
	this.waterMaxLevel = 2;

	this.$earth = $('<div class="garden-flower-earth"></div>');
	this.$flower = $('<div class="garden-flower-flower"></div>');

	this.init();
}

GardenFlower.prototype.init = function () {
	this.$container.append(this.$earth).append(this.$flower);
	this.$container.addClass("water-level-" + this.waterLevel);
	this.$container.addClass("game");

	this.tweenShow = TweenMax.fromTo(this.$flower, 1, {scale: 0}, {
		scale: 1,
		ease: Back.easeOut.config(3),
		paused: true
	});

	this.$container.on("click", $.proxy(this.click, this));
}

GardenFlower.prototype.click = function () {
	if (!this.game.started || this.animating) {
		return;
	}

	this.game.addWater(this.index);
};

GardenFlower.prototype.show = function () {
	this.$container.addClass("shown");
	this.tweenShow.pause(0).play();
};

GardenFlower.prototype.updateWaterLevel = function (quantity) {
	this.waterLevel = Math.min(this.waterMaxLevel, this.waterLevel + quantity);

	this.$container.alterClass("water-level-*", "water-level-" + this.waterLevel);

	if (this.waterLevel != this.waterMaxLevel) {
		this.animating = true;
		this.$container.one(window.transitionEnd, $.proxy(function () {
			this.animating = false;
		}, this));
	}

};

GardenFlower.prototype.result = function () {
	this.$container.addClass("result");
};

GardenFlower.prototype.destroy = function () {
	this.$flower.css("transform", "");
	this.$container.find(".garden-flower-earth").remove();
	this.$container.find(".garden-flower-flower").remove();
	this.$container.removeClass("water-level-" + this.waterLevel);
	this.$container.alterClass("water-level-*", "");
	this.$container.removeClass("game");
	this.$container.removeClass("result");
	this.$container.removeClass("shown");

	this.$flower = null;
	this.$earth = null;

	this.tweenShow  = null;

	this.$container.off("click", $.proxy(this.click, this));
};

// Expose Garden
window.GardenFlower = GardenFlower;

